
<div class="from-to">
  <input v-if="name === 'year'" v-debounce:600ms="update" type="text" ref="from" v-model="from" class="from-input" placeholder="От" />
  <input v-else v-debounce:600ms="update" type="text" ref="from" v-model="from" class="from-input" placeholder="От" v-currency="v_options" />
  <input v-if="name === 'year'" v-debounce:600ms="update" type="text" ref="to" v-model="to" class="to-input" placeholder="До" />
  <input v-else v-debounce:600ms="update" type="text" ref="to" v-model="to" class="to-input" placeholder="До" v-currency="v_options" />
</div>
